import {
  API_KEY,
  API_URL_TELECONSULTATION,
  API_URL_WITHOUT_USER,
} from "../../Utils/API";
import {
  getDispatch,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../Utils/helper";
import { HttpUtil } from "../../Utils/http-utils";
import ROUTES from "../../Utils/routesConstants";
import {
  getToken,
  GET_STATE_NAME,
  GET_CITY_NAME,
  VIEW_STATUS_BUTTON,
  getCampaignsToken,
  getTempararyTokenProviderAssist,
  getRole,
  GET_CLIENT_LIST,
  GET_MONTH_YEAR,
  GET_PROVIDER_CHAIN,
  GET_PROVIDER_BASED_ON_CHAIN,
  GET_PAYOUT_DASH,
} from "../../Utils/types";

export const uploadFileAction = (file, docType) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const formData = new FormData();
  formData.append("Image", file);
  formData.append("DocType", docType);
  const medium = window.location.search.split("=")[1];
  if (medium === "Email" || medium === "WhatsApp") {
    formData.append("Source", medium);
  } else if (getRole() === "NetworkAdmin") {
    formData.append("Source", "Network");
  }
  const url = window.location.pathname.includes("campaigns")
    ? `${API_URL_WITHOUT_USER}/Campaigns/UploadFile/${getCampaignsToken()}`
    : `${API_URL_WITHOUT_USER}/FileManager/UploadFile`;
  return HttpUtil.makePOST(url, formData, {
    ApiKey: API_KEY,
    Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
      ? getTempararyTokenProviderAssist()
      : window.location.pathname.includes("campaigns")
        ? null
        : getToken(),
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
    } else {
      isLoadingAction(false, dispatch);
    }
  });
};

export const uploadAccreditationDateAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = window.location.pathname.includes("campaigns")
    ? `${API_URL_WITHOUT_USER}/Campaigns/UploadFile/${getCampaignsToken()}`
    : `${API_URL_WITHOUT_USER}/FileManager/UploadFile`;
  // const url = `${API_URL_WITHOUT_USER}/FileManager/UploadFile`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
      ? getTempararyTokenProviderAssist()
      : window.location.pathname.includes("campaigns")
        ? null
        : getToken(),
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
    } else {
      isLoadingAction(false, dispatch);
    }
  });
};

export const deleteFileAction = (id, rowDelete) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = window.location.pathname.includes("campaigns")
    ? `${API_URL_WITHOUT_USER}/Campaigns/DeleteFileById/${getCampaignsToken()}?providerImageStgId=${id}&isRowDelete=${rowDelete}`
    : `${API_URL_WITHOUT_USER}/FileManager/DeleteFileById?providerImageStgId=${id}&isRowDelete=${rowDelete}`;
  // const url = `${API_URL_WITHOUT_USER}/FileManager/DeleteFileById?providerImageStgId=${id}&isRowDelete=${rowDelete}`;
  return HttpUtil.makePOST(
    url,
    {},
    {
      Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
        ? getTempararyTokenProviderAssist()
        : window.location.pathname.includes("campaigns")
          ? null
          : getToken(),
      ApiKey: API_KEY,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
    } else {
      isLoadingAction(false, dispatch);
    }
  });
};
export const GetClientListNetwork = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/Package/GetClientListNetwork`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    menuid: ""
  }).then((res) => {

    getDispatch(GET_CLIENT_LIST, res.data.results, dispatch)
    isLoadingAction(false, dispatch);
  });
};
export const GetPayoutDash = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  console.log(getToken());
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetpayoutDashboard`;
   return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    menuid: ""
  }).then((res) => {

    getDispatch(GET_PAYOUT_DASH, res.data.results, dispatch)
    isLoadingAction(false, dispatch);
  });
};
export const getMonthsYearsAction = () => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetMonthsYears`;
  return HttpUtil.makeGET(url, {}, {
    Authorization: getToken(),
    menuid: ""
  }).then((res) => {
    getDispatch(GET_MONTH_YEAR, res.data.results, dispatch)
    isLoadingAction(false, dispatch);
  });
};
export const getProviderChains = () => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetChainOrProviders?ChainId=0&IsChain=true`;
  return HttpUtil.makeGET(url, {}, {
    Authorization: getToken(),
    menuid: ""
  }).then((res) => {
    console.log("CHAIN", res)
    getDispatch(GET_PROVIDER_CHAIN, res.data.results, dispatch)
    isLoadingAction(false, dispatch);
  });
};
export const getProviderBasedOnChains = (chainId) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetChainOrProviders?ChainId=${chainId}&IsChain=false`;
  return HttpUtil.makeGET(url, {}, {
    Authorization: getToken(),
    menuid: ""
  }).then((res) => {
    console.log("CHAIN", res)
    getDispatch(GET_PROVIDER_BASED_ON_CHAIN, res.data.results, dispatch)
    isLoadingAction(false, dispatch);
  });
};

export const deletePermanentFileAction = (id, rowDelete) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = window.location.pathname.includes("campaigns")
    ? `${API_URL_WITHOUT_USER}/Campaigns/DeletePermanentById/${getCampaignsToken()}?ProviderImageId=${id}&isRowDelete=${rowDelete}`
    : `${API_URL_WITHOUT_USER}/FileManager/DeletePermanentById?ProviderImageId=${id}&isRowDelete=${rowDelete}`;
  // const url = `${API_URL_WITHOUT_USER}/FileManager/DeletePermanentById?ProviderImageId=${id}&isRowDelete=${rowDelete}`;
  return HttpUtil.makePOST(
    url,
    {},
    {
      Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
        ? getTempararyTokenProviderAssist()
        : window.location.pathname.includes("campaigns")
          ? null
          : getToken(),
      ApiKey: API_KEY,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
    } else {
      isLoadingAction(false, dispatch);
    }
  });
};

export const SubmitApprovalRequestAction = (moduleName) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = window.location.pathname.includes("campaigns")
    ? `${API_URL_WITHOUT_USER}/Campaigns/SendApprovalRequest/${getCampaignsToken()}?ModuleName=${moduleName}`
    : `${API_URL_WITHOUT_USER}/ApprovalProcess/SendApprovalRequest?ModuleName=${moduleName}`;
  return HttpUtil.makePOST(
    url,
    {},
    {
      Authorization: window.location.pathname.includes("campaigns")
        ? null
        : window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
          ? getTempararyTokenProviderAssist()
          : getToken(),
      ApiKey: API_KEY,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("success", "Changes submitted successfully", dispatch);
    } else {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};

export const getStateNameAction = () => (dispatch) => {
  const url = `${API_URL_TELECONSULTATION}/State/GetState?CountryId=${1}&api-version=1.0`;
  return HttpUtil.makeGET(url, {}, { Authorization: getToken() }).then(
    (res) => {
      getDispatch(GET_STATE_NAME, res?.data?.data, dispatch);
    }
  );
};

export const getCityNameAction = (id) => (dispatch) => {
  const url = `${API_URL_TELECONSULTATION}/City/GetCity?StateId=${id}&api-version=1.0`;
  return HttpUtil.makeGET(url).then((res) => {
    getDispatch(GET_CITY_NAME, res?.data?.data, dispatch);
  });
};

export const ViewRequestStatusAction = (moduleName) => (dispatch) => {
  const url = window.location.pathname.includes("campaigns")
    ? `${API_URL_WITHOUT_USER}/Campaigns/ViewRequestStatus/${getCampaignsToken()}?ModuleName=${moduleName}`
    : `${API_URL_WITHOUT_USER}/ApprovalProcess/ViewRequestStatus?ModuleName=${moduleName}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      Authorization: window.location.pathname.includes("campaigns")
        ? null
        : window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
          ? getTempararyTokenProviderAssist()
          : getToken(),
      ApiKey: API_KEY,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(VIEW_STATUS_BUTTON, res?.data?.results, dispatch);
    } else {
      getDispatch(VIEW_STATUS_BUTTON, null, dispatch);
    }
  });
};
